"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _entries = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/entries"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/typeof"));
require("core-js/modules/es6.array.filter.js");
require("core-js/modules/es6.array.map.js");
function cov_174voshan8() {
  var path = "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/Utils/lib/classNames.js";
  var hash = "5dbd0b5a780a5124217c1da95473c36cb5fb1262";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1825986617/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/helpers/Utils/lib/classNames.js",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 19
        },
        end: {
          line: 17,
          column: 28
        }
      },
      "1": {
        start: {
          line: 6,
          column: 34
        },
        end: {
          line: 17,
          column: 28
        }
      },
      "2": {
        start: {
          line: 7,
          column: 2
        },
        end: {
          line: 16,
          column: 3
        }
      },
      "3": {
        start: {
          line: 9,
          column: 6
        },
        end: {
          line: 9,
          column: 19
        }
      },
      "4": {
        start: {
          line: 11,
          column: 6
        },
        end: {
          line: 11,
          column: 114
        }
      },
      "5": {
        start: {
          line: 11,
          column: 61
        },
        end: {
          line: 11,
          column: 70
        }
      },
      "6": {
        start: {
          line: 11,
          column: 93
        },
        end: {
          line: 11,
          column: 102
        }
      },
      "7": {
        start: {
          line: 15,
          column: 6
        },
        end: {
          line: 15,
          column: 18
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 19
          },
          end: {
            line: 6,
            column: 20
          }
        },
        loc: {
          start: {
            line: 6,
            column: 34
          },
          end: {
            line: 17,
            column: 28
          }
        },
        line: 6
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 6,
            column: 45
          },
          end: {
            line: 6,
            column: 46
          }
        },
        loc: {
          start: {
            line: 6,
            column: 56
          },
          end: {
            line: 17,
            column: 1
          }
        },
        line: 6
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 11,
            column: 42
          },
          end: {
            line: 11,
            column: 43
          }
        },
        loc: {
          start: {
            line: 11,
            column: 61
          },
          end: {
            line: 11,
            column: 70
          }
        },
        line: 11
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 11,
            column: 76
          },
          end: {
            line: 11,
            column: 77
          }
        },
        loc: {
          start: {
            line: 11,
            column: 93
          },
          end: {
            line: 11,
            column: 102
          }
        },
        line: 11
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 7,
            column: 2
          },
          end: {
            line: 16,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 8,
            column: 4
          },
          end: {
            line: 9,
            column: 19
          }
        }, {
          start: {
            line: 10,
            column: 4
          },
          end: {
            line: 11,
            column: 114
          }
        }, {
          start: {
            line: 14,
            column: 4
          },
          end: {
            line: 15,
            column: 18
          }
        }],
        line: 7
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "5dbd0b5a780a5124217c1da95473c36cb5fb1262"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_174voshan8 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_174voshan8();
cov_174voshan8().s[0]++;
/**
 * Generates a string of space-separated class names based on the input parameters.
 * @param {...(string|Object<string, boolean>)} params - Input parameters representing class names or objects containing class names as keys and conditions as values.
 * @returns {string} - A string of space-separated class names.
 */
var classNames = function classNames() {
  cov_174voshan8().f[0]++;
  cov_174voshan8().s[1]++;
  for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }
  return params.map(function (param) {
    cov_174voshan8().f[1]++;
    cov_174voshan8().s[2]++;
    switch ((0, _typeof2.default)(param)) {
      case 'string':
        cov_174voshan8().b[0][0]++;
        cov_174voshan8().s[3]++;
        return param;
      // If the parameter is a string, return it unchanged
      case 'object':
        cov_174voshan8().b[0][1]++;
        cov_174voshan8().s[4]++;
        return (0, _entries.default)(param).filter(function (_ref) {
          var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
            condition = _ref2[1];
          cov_174voshan8().f[2]++;
          cov_174voshan8().s[5]++;
          return condition;
        }).map(function (_ref3) {
          var _ref4 = (0, _slicedToArray2.default)(_ref3, 1),
            className = _ref4[0];
          cov_174voshan8().f[3]++;
          cov_174voshan8().s[6]++;
          return className;
        }).join(' ');
      // If the parameter is an object, convert it to an array of class names based on truthy conditions
      // Then join they as className
      default:
        cov_174voshan8().b[0][2]++;
        cov_174voshan8().s[7]++;
        return null;
      // Return null for any other type of parameter
    }
  }).filter(Boolean).join(' ');
};
// Filter out any null values generated by default case, then join the resulting array into a string with spaces
var _default = exports.default = classNames;